import React, { Component } from 'react'
import styled from '@emotion/styled'
import { colors, fonts } from 'style/theme'
import {
  Menu,
  MenuList,
  MenuItem,
  MenuButton,
  MenuLink,
} from 'components/common/custom-reach-menu'
import { UserContext } from 'components/contexts/user'
import Link from 'gatsby-link'
import Cookies from 'universal-cookie'
import '@reach/menu-button/styles.css'
const cookies = new Cookies()

const userLinkStyles = `
  color: ${colors.primary.darkest} !important;
  text-decoration: none;
  font-weight: bold;
  display: inline-block;
  cursor: pointer;
  font-family: ${fonts.heading};
  &:hover {
    text-decoration: underline;
  }
`

const UserLoginLink = styled('a')`
  ${userLinkStyles};
  margin-right: 1rem;
`

const UserDropdownButton = styled(MenuButton)`
  border: none;
  background: transparent;
  cursor: pointer;
  margin-right: 1rem;
  font-weight: bold;
`

const UserDropdownMenuList = styled(MenuList)`
  border: 1px solid ${colors.black};
  padding: 0;
  font-family: ${fonts.body};
  a {
    color: ${colors.primary.darkest};
  }
`

const UserDropdownMenuLink = styled(MenuLink)`
  padding: 0.5rem;
  &:hover,
  &:focus {
    background: ${colors.primary.darkest};
    color: ${colors.white};
  }
  ${props =>
    props.isHidden &&
    `
    display: none;UserDropdownMenuLink
  `}
`

const UserDropdownMenuLinkButton = styled(MenuItem)`
  padding: 0.5rem;
  background: transparent;
  border: none;
  &:hover,
  &:focus {
    background: ${colors.primary.darkest};
    color: ${colors.white};
  }
`

const UserDashboardLink = styled(Link)`
  ${userLinkStyles};
  margin-right: 1rem;
`

class UserDropdown extends Component {
  state = {
    isEditor: false,
  }

  componentDidMount() {
    const sites = cookies.get('csumb-sites')
    this.setState({
      isEditor: sites && !Array.isArray(sites) && Object.keys(sites).length,
    })
  }

  handleLogout(event) {
    cookies.remove('csumb-sites')
    fetch(`https://csumb.okta.com/api/v1/sessions/me`, {
      credentials: 'include',
    })
      .then(response => {
        return response.json()
      })
      .then(session => {
        if (session && session.id) {
          fetch(
            `https://api.csumb.edu/okta/session/end?token=${session.id}`
          ).then(response => {
            window.location.href = `${window.location.protocol}//${
              window.location.host
            }`
          })
        }
      })
  }

  render() {
    const { user } = this.props
    const { isEditor } = this.state
    if (!user) {
      return null
    }
    return (
      <Menu buttonId="user-account-menu">
        <UserDropdownButton>
          Your account <span aria-hidden>▾</span>
        </UserDropdownButton>
        <UserDropdownMenuList>
          <UserDropdownMenuLink component="a" href="/account">
            Manage account
          </UserDropdownMenuLink>
          <UserDropdownMenuLink
            component="a"
            href="/account/profile"
            isHidden={!user._isEmployee}
          >
            Public profile
          </UserDropdownMenuLink>
          <UserDropdownMenuLink
            component="a"
            href="https://edit.csumb.edu/saml_login?destination=/"
            target="_blank"
            rel="noopener noreferrer"
            isHidden={!isEditor}
          >
            Edit website
          </UserDropdownMenuLink>
          <UserDropdownMenuLink component="a" href="/account/card">
            OtterCard
          </UserDropdownMenuLink>

          <UserDropdownMenuLink
            component="a"
            href="/account/schedule"
            isHidden={!user._isStudent}
          >
            Class schedule
          </UserDropdownMenuLink>
          <UserDropdownMenuLink
            component="a"
            href="/account/laundry"
            isHidden={!user._isStudent}
          >
            Laundry
          </UserDropdownMenuLink>
          <UserDropdownMenuLink component="a" href="/account/labs">
            Computer labs
          </UserDropdownMenuLink>
          <UserDropdownMenuLink component="a" href="/account/print">
            Print balance
          </UserDropdownMenuLink>
          <UserDropdownMenuLink component="a" href="/account/emergency">
            Emergency alerts
          </UserDropdownMenuLink>
          <UserDropdownMenuLinkButton onSelect={this.handleLogout.bind(this)}>
            Log out
          </UserDropdownMenuLinkButton>
        </UserDropdownMenuList>
      </Menu>
    )
  }
}

class UserWidget extends Component {
  render() {
    const { loginLink } = this.props
    return (
      <>
        <UserContext.Consumer>
          {context => (
            <>
              {context.user === false ? (
                <></>
              ) : (
                <>
                  {context.user.anonymous ? (
                    <UserLoginLink href={loginLink}>Log in</UserLoginLink>
                  ) : (
                    <>
                      {(context.user._isStudent ||
                        context.user._isEmployee) && (
                        <UserDashboardLink to="/dashboard">
                          Dashboard
                        </UserDashboardLink>
                      )}
                      <UserDropdown user={context.user} />
                    </>
                  )}
                </>
              )}
            </>
          )}
        </UserContext.Consumer>
      </>
    )
  }
}

export default UserWidget
